import axios from "axios";
 const accessTokenTo=sessionStorage.getItem("accToken") || localStorage.getItem("accToken");
export default axios.create({
  baseURL: process.env.React_App_AWS_API,
  headers: {
    "Content-type": "application/json",
     'Authorization': "Bearer "+accessTokenTo
    //'Authorization': accessTokenTo
  }
});